import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';


import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import StyledIntroduction from './styles';

import LaptopImage from '../../../assets/images/solution/laptop.png';


const Introduction = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [changeOpacity, setChangeOpacity] = useState(false);
    const [isTop, setIsTop] = useState(false);

    const label1 = t('whitelabel-sub-title');
    const label2 = t("whitelabel-content");
    const label2Mobile = t("whitelabel-content");
    const label3 = t('whitelabel-sub-content');
    const label3Mobile = t('whitelabel-sub-content');


    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleScroll = () => {
                const position = window.scrollY;
                if (position === 0) {
                    setIsTop(false);
                } else {
                    setIsTop(true);
                }
            };

            window.addEventListener('scroll', handleScroll);

            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, [isTop]);

    return (
        <StyledIntroduction>
            <Box
                sx={{
                    textAlign: { xs: 'center', md: 'center', lg: 'center' },
                    zIndex: 1,
                    position: 'relative',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
                    zIndex: 1,
                    padding: '5% 0% 5% 0%',
                    // backgroundColor: isTop ? '#02b201' : '#acfa4f',
                }}
            >
                <Typography
                    variant="h2"
                    component="h2"
                    sx={{
                        fontSize: '64px',
                        fontWeight: '900',
                        lineHeight: '76.38px',
                        color: '#000000',
                        [theme.breakpoints.down('lg')]: {
                            mt: 18,
                            fontSize: '55px',
                            lineHeight: '65.63px',
                        },
                    }}
                >
                    <motion.div
                        initial={{
                            opacity: 0,
                            y: 100,
                        }}
                        whileInView={{
                            opacity: 1,
                            y: 0, // Slide in to its original position
                            transition: {
                                duration: 1, // Animation duration
                            },
                        }}
                    // viewport={{ once: true }}
                    >
                        {parse(t("whitelabel-title"))}
                    </motion.div>
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        padding: '0 90px',
                        [theme.breakpoints.down('lg')]: {
                            padding: '0 20px',
                        },
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            lineHeight: '23.87px',
                            wordWrap: 'break-word',
                            fontWeight: 600,
                            fontSize: '20px',
                            mt: 2,
                            lineHeight: '29px',
                            color: '#121421',
                            [theme.breakpoints.down('lg')]: {
                                mt: 1,
                                fontSize: '20px',
                                lineHeight: '23.87px',
                                display: 'none',
                            },
                        }}
                    >
                        <motion.div
                            initial={{
                                opacity: 0,
                                y: 100,
                            }}
                            whileInView={{
                                opacity: 1,
                                y: 0, // Slide in to its original position
                                transition: {
                                    duration: 1, // Animation duration
                                    delay: 0.8,
                                },
                            }}
                        // viewport={{ once: true }}
                        >
                            <p>{parse(label2)}</p>
                        </motion.div>
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            lineHeight: 1.8,
                            wordWrap: 'break-word',
                            fontWeight: 600,
                            fontSize: '20px',
                            mt: 3,
                            lineHeight: '29px',
                            color: '#121421',
                            display: 'none',
                            [theme.breakpoints.down('lg')]: {
                                display: 'flex',
                                mt: 1,
                                fontSize: '20px',
                                lineHeight: '23.87px',
                            },
                        }}
                    >
                        <motion.div
                            initial={{
                                opacity: 0,
                                y: 100,
                            }}
                            whileInView={{
                                opacity: 1,
                                y: 0, // Slide in to its original position
                                transition: {
                                    duration: 1, // Animation duration
                                    delay: 0.8,
                                },
                            }}
                        // viewport={{ once: true }}
                        >
                            <p>{parse(label2Mobile)}</p>
                        </motion.div>
                    </Typography>
                </Box>
            </Box>
            {/* <Wave
        fill={isTop ? '#acfa4f' : '#02b201'}
        paused={false}
        style={{ display: 'flex', marginTop: '-33px', height: '50px', position: 'absolute', zIndex: 999 }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
      />
      <Wave
        fill={isTop ? '#acfa4f' : '#02b201'}
        paused={false}
        style={{ display: 'flex', marginTop: '-5px', height: '50px', transform: 'scaleY(-1)' }}
        options={{
          height: 10,
          amplitude: 20,
          speed: 0.25,
          points: 3,
        }}
      /> */}
            <Box
                sx={{
                    display: 'relative',
                    flexDirection: { xs: 'column', md: 'column', lg: 'row', xl: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: '100vh',
                    // backgroundColor: '#EFECF3',
                    color: theme.palette.background.secondary,
                    // px: 40,
                    // paddingTop: 15,
                    paddingBottom: 0,
                    paddingLeft: 15,
                    paddingRight: 10,
                    position: 'relative',
                    // zIndex: 999,
                    marginTop: '-50px',
                    marginBottom: '-163px',
                    [theme.breakpoints.down('lg')]: {
                        px: 1,
                        py: 1,
                        mb: 1,
                        justifyContent: 'space-between',
                        padding: '0 14px',
                        minHeight: 'unset',
                        marginTop: '-10px',
                        zIndex: 1,
                    },
                }}
            >
                <Grid
                    container
                    rowSpacing={0}
                    columnSpacing={{ xs: 0, sm: 0, md: 0, lg: 5, xl: 5 }}
                    sx={{
                        backgroundColor: '#EFECF3',
                        paddingTop: 5,
                        [theme.breakpoints.down('lg')]: {
                            paddingTop: 5,
                            paddingLeft: '20px',
                            paddingRight: '20px',
                            width: 'unset',
                            marginLeft: 'unset',
                        }
                    }}
                >
                    {/* Left Content */}
                    <Grid item xs={12} md={12} lg={5} xl={5}>
                        {/* <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' }, zIndex: 1 }}> */}
                        <Box
                            sx={{
                                display: { xs: 'flex', md: 'flex', lg: 'none', xl: 'none' },
                                flex: 1,
                                // display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                //  marginTop: -15,
                                // marginRight: 5,
                                '& img': {
                                    width: '400px',
                                    height: '386px',
                                },
                                [theme.breakpoints.down('lg')]: {
                                    '& img': {
                                        // mt: 5,
                                        width: '360px',
                                        height: '206px',
                                    },
                                },
                            }}
                        >
                            {/* Replace with actual image */}
                            <img
                                src={LaptopImage}
                                alt="Jade Soft Graphics"
                                style={{
                                    //   width: '400px',
                                    //   height: '386px',
                                    // maxWidth: '100%',
                                    // height: '100%',
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'cover',
                                }}
                            />
                        </Box>

                        <Typography
                            variant="body1"
                            sx={{
                                mt: 0,
                                mb: 2,
                                // ml: 5,
                                lineHeight: '59.67px',
                                wordWrap: 'break-word',
                                fontWeight: 800,
                                fontSize: '50px',
                                color: '#444444',
                                [theme.breakpoints.down('lg')]: {
                                    fontSize: '40px',
                                    lineHeight: '47.73px',
                                    textAlign: 'center',
                                    mt: 4,
                                    // padding: '20px',
                                },
                            }}
                        >
                            {parse(label1)}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                // ml: 5,
                                lineHeight: '23.87px',
                                // wordWrap: 'break-word',
                                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                fontSize: '20px',
                                color: '#676767',
                                [theme.breakpoints.down('lg')]: {
                                    display: 'none',
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    lineHeight: '23.4px',
                                    textAlign: 'center',
                                    padding: '20px',
                                },
                            }}
                        >
                            {parse(label3)}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                // ml: 5,
                                lineHeight: '26px',
                                // wordWrap: 'break-word',
                                fontWeight: 800,
                                fontSize: '20px',
                                color: '#676767',
                                display: 'none',
                                [theme.breakpoints.down('lg')]: {
                                    display: 'block',
                                    fontSize: '18px',
                                    fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                    lineHeight: '21.48px',
                                    textAlign: 'center',
                                    padding: '15px',
                                },
                            }}
                        >
                            {parse(label3Mobile)}
                        </Typography>
                        <Box
                            sx={{
                                [theme.breakpoints.down('lg')]: {
                                    padding: '0 20px',
                                    justifyContent: 'center',
                                    display: 'flex',
                                },
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={() => navigate('/contact')}
                                sx={{
                                    display: 'flex',
                                    color: '#fff',
                                    backgroundColor: '#5B3EDE',
                                    borderColor: '#00AA2F',
                                    borderRadius: '4px',
                                    width: '120.39px',
                                    height: '45px',
                                    // marginRight: '30px',
                                    marginTop: 4,
                                    fontSize: '16px',
                                    fontWeight: 800,
                                    width: localStorage.getItem('i18nextLng') === 'en-US' ? '150.39px' : '120.39px',
                                    [theme.breakpoints.down('lg')]: {
                                        marginTop: 4,
                                        marginBottom: 5,
                                        // width: '100%',
                                        justifyContent: 'center',
                                        '@media (max-width: 390px)': {
                                            marginBottom: 5,
                                        },

                                        '@media (max-width: 375px)': {
                                            marginBottom: 5,
                                        },
                                    },
                                }}
                            >
                                {t('whitelabel-button-label')}
                            </Button>
                        </Box>
                    </Grid>
                    {/* Right Content */}
                    <Grid item xs={12} md={12} lg={7} xl={7}>
                        <Box
                            sx={{
                                display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' },
                                flex: 1,
                                // display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                marginTop: -15,
                                marginRight: 5,
                            }}
                        >
                            {/* Replace with actual image */}
                            <img
                                src={LaptopImage}
                                alt="Jade Soft Graphics"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    // maxWidth: '100%',
                                    // height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            {/* <Wave
        fill="#fff"
        paused={false}
        style={{ display: 'flex', marginTop: '-40px', height: '50px' }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
      /> */}
        </StyledIntroduction>
    );
};

export default Introduction;
